import { render, staticRenderFns } from "./troubleshooting.vue?vue&type=template&id=1ad36eb2&scoped=true"
import script from "./troubleshooting.vue?vue&type=script&lang=js"
export * from "./troubleshooting.vue?vue&type=script&lang=js"
import style0 from "./troubleshooting.vue?vue&type=style&index=0&id=1ad36eb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad36eb2",
  null
  
)

export default component.exports